import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { AutorunComponent } from '@myshared/autorun.component';
import { Model } from 'src/app/app.model';
import { Subscription } from 'src/app/subscription/subscription.model';
import { SubscriptionService } from 'src/app/subscription/subscription.service';
import { observable, action } from '@myshared/mobx-connector';
import { runInAction } from 'mobx';
import { filterText } from '@myshared/utils';

@Component({
  selector: 'app-support-select-subscription-v2',
  templateUrl: './support-select-subscription-v2.component.html',
  standalone: false
})
export class SupportSelectSubscriptionV2Component extends AutorunComponent implements OnInit{

  @Output()
  onSubscriptionSelected = new EventEmitter<Subscription>();

  public subscriptions: Subscription[];

  @observable private searchText$;

  constructor(private m: Model,
              private subscriptionService: SubscriptionService) {
        super();
  }

  ngOnInit(): void {
    runInAction(() => this.filterLicenses(''));
    this.autorun(() => {
      this.subscriptions = filterText(this.m.subscription.subscriptions, this.searchText$)
        .filter(s => s.isValid);
    });
    this.subscriptionService.refresh(true);
  }

  selectSubscription(subscription: Subscription) {
    this.onSubscriptionSelected.emit(subscription);
  }

  @action filterLicenses(value: string) {
    this.searchText$ = value;
  }

}
